import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex whitespace-nowrap" }
const _hoisted_2 = { class: "flex flex-col text-sm" }
const _hoisted_3 = { class: "text-[8px]" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("table", {
    ref: "table",
    onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onmouseup && _ctx.onmouseup(...args))),
    onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onmousemove && _ctx.onmousemove(...args)))
  }, [
    _createElementVNode("thead", null, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.cols,
        "onUpdate:modelValue": _ctx.updateCols,
        tag: "tr",
        "item-key": name => name
      }, {
        header: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("th", null, null, -1)
        ])),
        item: _withCtx(({ element:h, index:i}) => [
          _createElementVNode("th", {
            class: _normalizeClass([[h.class, !h.visible ? 'hidden': ''], "p-2 relative select-none"]),
            style: _normalizeStyle(_ctx.getStyleWidth(h))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, [
                _createTextVNode(_toDisplayString(h.name) + " ", 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(h.prop), 1)
              ]),
              _withDirectives(_createElementVNode("span", {
                class: "ml-2",
                onClick: _withModifiers(($event: any) => (_ctx.reorder(h,i)), ["exact"])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa fa-chevron-up transition-transform origin-center cursor-pointer", _ctx.icon(i)])
                }, null, 2)
              ], 8, _hoisted_4), [
                [_vShow, h.orderable]
              ])
            ]),
            _withDirectives(_createElementVNode("span", {
              onMousedown: _withModifiers(($event: any) => (_ctx.onmousedown($event, h)), ["stop","prevent"]),
              class: "z-10 absolute top-0 bottom-0 w-1.5 right-0 translate-x-1/2 bg-next-gray-md-darker rounded cursor-col-resize"
            }, null, 40, _hoisted_5), [
              [_vShow, h.resizable]
            ])
          ], 6)
        ]),
        footer: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("th", { class: "px-4" }, null, -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue", "item-key"])
    ]),
    _createVNode(_component_draggable, {
      tag: "tbody",
      modelValue: _ctx.rows,
      "onUpdate:modelValue": _ctx.updateRows,
      "item-key": "uuid",
      draggable: ".main_row",
      handle: ".drag-handle"
    }, {
      item: _withCtx(({element:r, index:i}) => [
        _createElementVNode("tr", {
          class: _normalizeClass({'main_row': !(r._nuvola || r._alternativa)})
        }, [
          _createElementVNode("td", null, [
            _renderSlot(_ctx.$slots, `td_${i}_preactions`, _normalizeProps(_guardReactiveProps({row: r})))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (c, j) => {
            return (_openBlock(), _createElementBlock("td", {
              key: `${i}_${j}`,
              class: _normalizeClass(["border-2 relative p-0", [c.td_class, !c.visible ? 'hidden': '', r._nuvola||r.nuvole?.length ? _ctx.nuvola_td_class: r._alternativa||r.alternative?.length ? _ctx.alternativa_td_class: _ctx.isOpzionale(r)? _ctx.opzionale_td_class: 'border-next-light-gray' ]])
            }, [
              _renderSlot(_ctx.$slots, `td_${i}_${c.prop}`, _mergeProps({ ref_for: true }, {row: r, cell: c}), () => [
                _createTextVNode(_toDisplayString(r[c.prop]), 1)
              ])
            ], 2))
          }), 128)),
          _createElementVNode("td", {
            class: _normalizeClass(_ctx.$attrs.actionClass)
          }, [
            _renderSlot(_ctx.$slots, `td_${i}_actions`, _normalizeProps(_guardReactiveProps({row: r})))
          ], 2)
        ], 2)
      ]),
      _: 3
    }, 8, ["modelValue", "onUpdate:modelValue"])
  ], 544))
}